import { render, staticRenderFns } from "./AppBrowseContacts.vue?vue&type=template&id=04663235&scoped=true"
import script from "./AppBrowseContacts.vue?vue&type=script&lang=js"
export * from "./AppBrowseContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04663235",
  null
  
)

export default component.exports